import createVueApp from '../../shared/vue/create-app';
import initCustomControls from '../../components/custom-controls';
import VueMultiselectExtended from '../../components/inputs/multiselect';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';

const initHowItWorksPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        components: {
            Multiselect: VueMultiselectExtended,
        },
        data() {
            return {
                selectedOption: opts.selectedOption,
                isBuyLocationMode: opts.isBuyLocationMode,
            };
        },
        computed: {
        },
        methods: {
            isSelected(value) {
                return this.selectedOption === value;
            },
        },
    });

    initCustomControls(app);
    initCustomInputsComponents(app);

    app.mount(opts.el);
};

export {initHowItWorksPage};
